export const port = 'https://epamkk.projectsoft.co.th/api/v1'
// export const port = 'http://203.144.243.102/api/v1'
// export const port = 'http://192.168.1.103:3005/api/v1'

export const get = (url, token) =>
    new Promise((resolve, reject) =>
        fetch(port + url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json',
                Authorization: token
            },
            credentials: 'include',
        }).then(result => result.json())
            .then(json => json.success ? resolve(json) : reject(json.error_message ? json.error_message : 'get error'))
            .catch(err => reject('get data error from fetch'))
    )

export const post = (url, obj, token) =>
    new Promise((resolve, reject) =>
        fetch(port + url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json',
                Authorization: token
            },
            credentials: 'include',
            body: JSON.stringify(obj)
        }).then(result => result.json())
            .then(json => json.success ? resolve(json) : reject(json.error_message ? json.error_message : 'post error'))
            .catch(err => reject('get data error from fetch'))
    )

export const postFile = (url, data, token) =>
    new Promise((resolve, reject) =>
        fetch(port + url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': token
            },
            body: data,
            credentials: 'include',
        }).then(result => result.json())
            .then(json => json.success ? resolve(json) : reject('error while upload file'))
            .catch(err => reject('error while upload file'))
    )

export const getImg = (url, token) =>
    new Promise((resolve, reject) =>

        fetch(port + url, {
            method: 'GET',
            headers: {
                'Authorization': token
            },
            credentials: 'include'
        }).then(res => res.blob())
            .then(content => {
                const urlCreator = window.URL || window.webkitURL

                const avatar = urlCreator.createObjectURL(content)
                resolve(avatar)
            })
            .catch(err => reject(err))
    )


// export const fileUploadWithFuctionGeneretor = (url, token, arr) => {
//     fetch(port + url, {
//         method: 'POST',
//         headers: {
//             'Accept': 'application/json',
//             'Authorization': token
//         },
//         body: data,
//         credentials: 'include',
//     })
//         .then(result => result.json())
//         .then(json => json.success ? resolve(true) : reject('error while upload file'))
//         .catch(err => reject('error while upload file'))
// }

// export function* fileUploadGenerator(arr) {
//     while (true) {
//         yield 
//     }

// }


// export const longRunFileUpload = (generator) => {
//     if (!generator) {
//         generator = fileUploadGenerator()

//     }

// }


// WEBPACK FOOTER //
// ./src/service/index.js